import { render, staticRenderFns } from "./NovaInlineRadio.vue?vue&type=template&id=1f7a32a5&lang=pug&"
import script from "./NovaInlineRadio.vue?vue&type=script&lang=js&"
export * from "./NovaInlineRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports